<template>
	<div class="ui-file wrapper">
		<div v-if="tip" class="ui-file__tip form-block__tip">
			<UiTip
				:message="tip.message"
			/>
		</div>
		<div class="upload-block" :class="uploadClasses">
			<div class="ui-file__header">
				<span class="upload-block-title">{{ title }}</span>
			</div>
			<div class="ui-file__container"
				:class="{
					'ui-file__container-m-0': showInfoInput
				}">
				<span v-if="subtitle" class="upload-block-subtitle">{{ subtitle }}</span>
				<div v-if="showInfoInput" class="ui-file__container--link">
					<label v-if="labelInputInfo">{{labelInputInfo}}</label>
					<input
						v-model="infoInputValue"
						type="text"
						:readonly="true"
						:placeholder="placeholderInfo"
					>
				</div>
				<div class="ui-file__container--link">
					<label v-if="labelInput">{{labelInput}}</label>
					<input
						v-model="modelProxy"
						type="text"
						:disabled="disabled"
						:readonly="readonly"
						:placeholder="placeholder"
						@input="modelProxy = $event.target.value"
					>
				</div>
				<span v-show="error" class="input-caption input-caption__error">
					{{ error }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "UiLinkFile",
	model: {
		prop: 'modelValue',
		event: 'emitValue'
	},
	props: {
		/**
     * Значение поля
     * тип может быть любой
     * @type {any}
     */
		modelValue: {},

		/**
     * Информационное дополнительное поле
     */
		infoInputValue: {},
		/**
     * Объект подсказки
     */
		tip: {
			type: Object,
			default: null,
		},
		/**
     * Аттрибут [readonly]
     * @type {boolean}
     */
		readonly: {
			type: Boolean,
			default: false
		},
		disabled:{
			type: Boolean,
			default: false
		},
		/**
     * Сообщение об ошибке. (отображается под селектом, заменяет hint)
     */
		error: {
			type: String,
			default: '',
		},
		/**
     * Заголовок блока указания файла
     */
		title: {
			type: String,
			required: false
		},
		/**
     * Подзаголовок блока указания файла
     */
		subtitle: {
			type: String,
			required: false
		},
		placeholder: {
			type: String,
			default: ''
		},
		placeholderInfo: {
			type: String,
			default: ''
		},
		labelInput: {
			type: String,
		},
		labelInputInfo: {
			type: String,
		},
		showInfoInput: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		modelProxy: {
			get() {
				return this.modelValue;
			},
			set(value) {
				this.$emit('emitValue', value);
			},
		},
		uploadClasses() {
			return {
				'upload-block__error': this.error,
				'upload-block__disabled': this.disabled,
			}
		},
	},
}
</script>